// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSwitch-Title_cls1__XZHsJ","cls2":"VeloSwitch-Title_cls2__Qn9NK VeloSwitch-Title_cls1__XZHsJ"};